import { useEffect, useSyncExternalStore } from 'react';
import type { AppHeaderProps } from './app-header';

const DEFAULT_CONFIG: AppHeaderProps = {};

let config: AppHeaderProps = DEFAULT_CONFIG;

const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

function getSnapshot() {
  return config;
}

function shallowEqual(a: AppHeaderProps, b: AppHeaderProps): boolean {
  const aKeys = Object.keys(a) as (keyof AppHeaderProps)[];
  const bKeys = Object.keys(b) as (keyof AppHeaderProps)[];
  if (aKeys.length !== bKeys.length) return false;
  return aKeys.every((key) => a[key] === b[key]);
}

export function setAppHeaderConfig(next: AppHeaderProps) {
  if (shallowEqual(config, next)) return;
  config = next;
  emit();
}

export function resetAppHeaderConfig() {
  if (config === DEFAULT_CONFIG) return;
  config = DEFAULT_CONFIG;
  emit();
}

export function useAppHeaderConfig(): AppHeaderProps {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function useAppHeader(next: AppHeaderProps) {
  useEffect(() => {
    setAppHeaderConfig(next);
  });
  useEffect(() => () => resetAppHeaderConfig(), []);
}
